// extracted by mini-css-extract-plugin
export default {"wrapper":"ArrowSwitcher_wrapper__gswHN"};